'use client';

import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      position="bottom-right"
      duration={3000}
      toastOptions={{
        classNames: {
          toast:
            'group rounded-lg shadow-lg flex items-center gap-3 min-w-[280px] max-w-[400px] px-4 py-3 text-sm font-medium',
          success: 'bg-success text-white dark:text-neutral-950 border-success',
          error: 'bg-error text-white dark:text-neutral-950 border-error',
          warning: 'bg-warning text-white dark:text-neutral-950 border-warning',
          info: 'bg-info text-white dark:text-neutral-950 border-info',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
